import {PageItem} from '@taopix/taopix-core/dist/types/types';
import {
  AUTOFIT_TEXT_SCALE_RESOLUTION,
  AutoFitMode,
  Lang,
  NumBool,
  Text,
  TextStoreKeys,
} from '@taopix/taopix-core';

export const formatBox = (item: PageItem) => {
  const pageItem = window.Taopix.Core.get('utils').deepClone(item);

  const unflattenedStyledText = Text.unflattenText(
    pageItem.styledtext.data,
    pageItem.styledtext.defaultstyledata,
    {},
    {},
    pageItem.labelusedefaulttextstyle
  );

  const boxData = {
    autofitmode:
      AutoFitMode.Off === pageItem.styledtext.autofitmode
        ? AutoFitMode.ShrinkToFit
        : pageItem.styledtext.autofitmode,
    autofitscale: AUTOFIT_TEXT_SCALE_RESOLUTION,
    boxheight: pageItem.boxheight,
    boxwidth: pageItem.boxwidth,
    data: Text.flattenText(unflattenedStyledText, item.text).data,
    direction: pageItem.styledtext.direction,
    marginbottom: pageItem.styledtext.marginbottom,
    marginleft: pageItem.styledtext.marginleft,
    marginright: pageItem.styledtext.marginright,
    margintop: pageItem.styledtext.margintop,
    missingfonts: pageItem.styledtext.missingfonts,
    missingglyphfonts: pageItem.styledtext.missingglyphfonts,
    origstyledtextautofitmode: pageItem.styledtext.origstyledtextautofitmode,
    performfontfallback: NumBool.True,
    processdefaultlabel: 0,
    textoverflowed: pageItem.styledtext.textoverflowed,
    verticalalignment: pageItem.styledtext.verticalalignment,
    processtime: new Date().getTime(),
  };

  return {
    ref: pageItem.ref,
    box: boxData,
    item: {
      metadata: pageItem.metadata,
      name: pageItem.name,
    },
  };
};

export const flightCheckText = payload => {
  return Text.fetchBassData(
    {
      browserLanguageCode: Lang.getCode(),
      engineConfiguration: Text.store.get(TextStoreKeys.TEXT_ENGINE_CONFIG),
      box: [payload.box],
      item: [payload.item],
    },
    {arrayResponse: true}
  );
};

/**
 * Extracts the user text.
 *
 * @param rawData The styled text data string to get the text.
 * @returns The user text, if found.
 */
export const getText = (rawData: string): string => {
  return rawData.split('>').pop() || '';
};
